// frontend/src/components/quiz/QuizTypeBadge.js
import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { getQuizTranslation } from "../../utils/quizTranslations";

const QuizTypeBadge = ({ quizType }) => {
  const { language } = useLanguage();

  const colors = {
    practice: "bg-blue-500 text-white",
    graded: "bg-[#EE005F] text-white", // burnair Primary color
    pre_assessment: "bg-gray-600 text-white",
    post_assessment: "bg-[#04A777] text-white", // burnair Secondary color
  };

  const translatedType = getQuizTranslation(`quizTypes.${quizType}`, language);

  return (
    <span
      className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${
        colors[quizType] || colors.practice
      }`}
    >
      {translatedType}
    </span>
  );
};

export default QuizTypeBadge;
